<div class="treshold-notification">
  <div class="title-invoices-container">
    <h4 class="title-invoices">Seuil minimum du montant des factures</h4>
  </div>

  @if (loading) {
    <div class="spinner-wrapper">
      <app-spinner [mainColor]="Color.primary600" [secondColor]="Color.white" [diameter]="'2rem'"></app-spinner>
    </div>
  } @else {
    @if (error) {
      <div class="error-alerts">
        <app-report-message
          [type]="alertLogLevel.ERROR"
          [message]="'Une erreur est survenue. Si le problème persiste merci de prévenir les équipes.'"
          data-testid="threshold-error-message"
        >
        </app-report-message>
      </div>
    } @else {
      <div data-testid="threshold-notif-container" class="text-invoices">
        <p>
          Seuil du montant minimum enregistré :
          <b>{{ tresholdSaved | number: '1.0-0' }} €</b>
        </p>
        <p>
          Nombre de factures en dessous du seuil :
          <b>{{ invoicesLess }}</b>
        </p>
      </div>
    }
  }
</div>
